import { useCallback } from 'react';

import useRestClient from '@/hooks/useRestClient';

import { REPORT_DATA_QUERY_KEY } from '../../views/ReportEditor/hooks/useChartData/utils';

const useInvalidateReportingQuery = () => {
  const queryClient = useRestClient();

  const invalidateReportingQuery = useCallback(
    (key?: string) => {
      queryClient.invalidateQueries(key ?? REPORT_DATA_QUERY_KEY);
    },
    [queryClient],
  );

  return invalidateReportingQuery;
};

export default useInvalidateReportingQuery;
